import React from 'react';
import styled from 'styled-components';
import WebContainer from './web';
import SectionListContainer from './section-list-container';

export type ReducedEmbedSectionItems = {
  id: string;
  publishedAt: string;
  url: string;
  updatedAt: string;
  title: string;
  imageId: string;
  tagSlugs: string[];
  commentsNb: string;
  lead: string;
  authors: string[];
};

export type ClubicEmbedProps = {
  embedType: string;
  embedTitle: string;
  embedDescription: string;
  url: string;
  id?: string;
  label?: string;
  isSectionList?: boolean;
  embedImageId?: string;
  embedLabel?: string;
  embedItemType?: string;
  embedSponso?: boolean;
  embedDate?: string;
  embedExtensionImg?: string;
  embedTitleImg?: string;
  embedDisplayedDate?: boolean;
  itemList?: ReducedEmbedSectionItems[];
};

export type ClubicItemEmbedProps = ClubicEmbedProps & {};

export type ClubicSectionEmbedProps = ClubicEmbedProps & {};

interface Renderer {
  handles: (state: ClubicItemEmbedProps | ClubicSectionEmbedProps) => boolean;
  mediaCell: boolean;
  Component: React.FC<ClubicItemEmbedProps | ClubicSectionEmbedProps>;
}

const Renderers: Renderer[] = [
  {
    handles: (state): boolean => {
      return state.embedType === 'section' && state.isSectionList && state?.itemList?.length > 0;
    },
    mediaCell: true,
    Component: SectionListContainer,
  },
  {
    handles: (state): boolean => {
      return state.embedType === 'section' && !state.isSectionList;
    },
    mediaCell: true,
    Component: WebContainer,
  },
  {
    handles: (state): boolean => {
      return state.embedType !== 'section';
    },
    mediaCell: true,
    Component: WebContainer,
  },
];

const MediaCell = styled.div`
  margin: var(--spacer-s) 0 var(--spacer-s);
`;

const ClubicEmbed = (state: ClubicEmbedProps) => {
  const currentRenderer = Renderers.find((renderer) => renderer.handles(state));

  if (currentRenderer) {
    if (currentRenderer.mediaCell) {
      return (
        <MediaCell>
          <currentRenderer.Component {...state} />
        </MediaCell>
      );
    }

    return <currentRenderer.Component {...state} />;
  }

  return null;
};

export default ClubicEmbed;
